const GAP_SIZE = 16 // gap-m = 16px
const MIN_SIZE = 80
const MAX_SIZE = 160
const TABLET_BREAKPOINT = 768

export const calculateDragPreviewSize = (screenWidth: number): number => {
  // Calculate grid item size based on screen width (3 columns with gaps)
  const availableWidth = screenWidth - 2 * GAP_SIZE // 2 gaps between 3 items
  const gridItemSize = availableWidth / 3

  const reductionFactor = screenWidth >= TABLET_BREAKPOINT ? 0.7 : 0.925
  const previewSize = Math.round(gridItemSize * reductionFactor)

  // Set reasonable bounds
  return Math.max(MIN_SIZE, Math.min(MAX_SIZE, previewSize))
}

export const getInitialDragPreviewSize = (): number => {
  return calculateDragPreviewSize(window.innerWidth)
}
